import axios from '@/axios'

export default {
  get() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/menu`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
